import { gql } from "apollo-angular";

export const REQUEST_ADD_TO_CART_QUERY = gql`{

  carts (Function:"Add")
  {
    code
  }

  }`;


  export const ADD_TO_CART_QUERY = gql`{

    carts (Function: "Add")
    {
      id
    }

  }`;


  // export const FETCH_CART_QUERY = gql`{

  //   carts (Function: "Filters")
  //   {
  //     id
  //     cart_product_specification {
  //       attribute_id
  //       attributes_options_id
  //       attribute_options {
  //         name_en
  //       }
  //     }
  //     amount
  //     price
  //     product {
  //       name_en
  //       description_en
  //       photo
  //     }
  //   }

  // }`;


  export const FETCH_CART_QUERY = (lang: string)=> gql`{

    carts (Function: "Filters")
    {
      id
      cart_product_specification {
        attribute_id
        attributes_options_id
        attribute_options {
          attributes_options{
              name: name_${lang}
          }
        }
      }
      storeAmount
      amount
      price
      product {
        name: name_${lang}
        description: description_${lang}
        photo
        brand {
          name: name_${lang}
        }
        offers {
          id
          percentage
        }
      }
    }

  }`;



  export const DELETE_CART_QUERY = gql`{

    carts (Function: "Delete")
    {
      id
    }

  }`;


  export const UPDATE_CART_QUERY = gql`{

    carts (Function: "Edit")
    {
      id
    }

  }`;

